import { render, staticRenderFns } from "./modifyAddress.vue?vue&type=template&id=7b4bf494&"
import script from "./modifyAddress.vue?vue&type=script&lang=js&"
export * from "./modifyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports